export const WOOP_MNEMONIC = 'woop-direct';
